export const FEATURE_REQUEST_CATEGORIES = [
  'workflow',
  'automation',
  'integrations',
  'analytics',
  'performance',
  'ux',
  'other',
] as const;

export type FeatureRequestCategory =
  (typeof FEATURE_REQUEST_CATEGORIES)[number];

export const FEATURE_REQUEST_STATUSES = [
  'proposed',
  'planned',
  'in_progress',
  'released',
] as const;

export type FeatureRequestStatus = (typeof FEATURE_REQUEST_STATUSES)[number];

export type RequestSortMode = 'top' | 'trending' | 'newest';

export type RequestStatusFilter = FeatureRequestStatus | 'all';

export interface FeatureVote {
  voterId: string;
  voterName: string;
  createdAt: string;
}

export interface FeatureRequest {
  id: string;
  title: string;
  description: string;
  category: FeatureRequestCategory;
  status: FeatureRequestStatus;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  createdById: string | null;
  votes: FeatureVote[];
}

export interface ViewerIdentity {
  id: string;
  name: string;
}

export interface AddFeatureRequestInput {
  title: string;
  description: string;
  category: FeatureRequestCategory;
}
